import React from 'react';
import Section from './Section';
import Button from './Button';

const CTASection = ({ 
  title, 
  description, 
  buttonText, 
  buttonLink, 
  buttonVariant = "white", 
  buttonSize = "lg",
  background = "primary",
  scrollToId
}) => {
  return (
    <Section background={background}>
      <div className="text-center">
        <h2 className="text-3xl font-bold text-white mb-6">{title}</h2>
        <p className="max-w-2xl mx-auto text-lg text-white mb-10 leading-relaxed">
          {description}
        </p>
        <Button 
          to={buttonLink} 
          variant={buttonVariant}
          size={buttonSize}
          scrollTo={scrollToId}
        >
          {buttonText}
        </Button>
      </div>
    </Section>
  );
};

export default CTASection;